var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cn } from '../../lib/utils.js';
import { Select, SelectContent as SelectContentPrimitive, SelectGroup, SelectItem, SelectLabel, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator, SelectTrigger as SelectTriggerPrimitive, SelectValue, } from './primitives/select';
function CustomSelectTrigger(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return <SelectTriggerPrimitive className={cn('w-full', className)} {...props}/>;
}
function CustomSelectContent(_a) {
    var props = __rest(_a, []);
    return <SelectContentPrimitive position="popper" {...props}/>;
}
export { Select, CustomSelectContent as SelectContent, SelectGroup, SelectItem, SelectLabel, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator, CustomSelectTrigger as SelectTrigger, SelectValue, };
